module.exports = __webpack_public_path__ + "static/media/fork.8bab732c.svg";